import axios from 'axios'
import router from '@/routes'
import cookies from '@/services/cookies'
import { Logger } from '@/services/logger'
import config from '../../config'

export const HTTP = axios.create({
  baseURL: config.API_URL
})

const whitelistTokens = ['login', 'forgot-password']

const addToken = url => {
  const token = `access_token=${cookies.get('jwt_token')}`
  url = url.includes('?') ? url += `&${token}` : url += `?${token}`
  return url
}

const getDefaultHeaders = () => {
  return {
    common: {
      authorization: cookies.get('jwt_token')
    },
    'Content-Type': 'application/json'
  }
}

export const onError = (error) => {
  let errorInfo, response, request, message
  try {
    response = error.response
    request = error.request
    message = error.message
  } catch (err) {}

  if (response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    errorInfo = error.response.data
  } else if (request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    errorInfo = error.request
  } else {
    // Something happened in setting up the request that triggered an Error
    errorInfo = message
  }
  Logger.obj(errorInfo)
  return errorInfo
}

export const httpGET = (url) => {
  url = addToken(url)
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = getDefaultHeaders()
    return HTTP.get(url)
      .then((resp) => {
        resolve(resp.data)
      })
      .catch((err) => {
        onError(err)
        reject(err)
      })
  })
}

export const httpPOST = (url, data, headerParams = {}) => {
  const isWhiteListed = whitelistTokens.some(u => url.includes(u))
  url = isWhiteListed ? url : addToken(url)
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = getDefaultHeaders()

    /* Overrides/adds header properties needed beyond the defaults. */
    Object.keys(headerParams).forEach((key) => {
      HTTP.defaults.headers[key] = headerParams[key]
    })

    return HTTP.post(url, data)
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(err => {
        reject(onError(err))
      })
  })
}

export const httpPATCH = (url, data) => {
  url = addToken(url)
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = getDefaultHeaders()
    return HTTP.patch(url, data)
      .then((resp) => {
        resolve(resp.data)
      })
      .catch((err) => {
        onError(err)
        reject(err)
      })
  })
}

export const httpPUT = (url, data) => {
  url = addToken(url)
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = getDefaultHeaders()
    return HTTP.put(url, data)
      .then((resp) => {
        resolve(resp.data)
      })
      .catch((err) => {
        onError(err)
        reject(err)
      })
  })
}

export const httpDELETE = (url, headerParams = {}) => {
  url = addToken(url)
  return new Promise((resolve, reject) => {
    HTTP.defaults.headers = getDefaultHeaders()

    /* Overrides/adds header properties needed beyond the defaults. */
    Object.keys(headerParams).forEach((key) => {
      HTTP.defaults.headers[key] = headerParams[key]
    })

    return HTTP.delete(url)
      .then((resp) => {
        resolve(resp.data)
      })
      .catch(onError)
  })
}

export const goTo404 = () => {
  router.push({ path: '/404' })
}
